<template>
    <v-container>
        <h1>Clients list</h1>
        <p>Vestibulum ut risus eget nunc semper consequat vitae et tortor. Vivamus at mi dictum, mollis purus non,
            pretium odio. </p>
        <v-item-group justify="space-between" active-class="primary">
            <v-container>
                <v-row>
                    <v-col v-if="loading" cols="12" sm="6" md="4" lg="3">
                        <CardLoader :maxHeight="205"></CardLoader>
                    </v-col>
                    <template v-if="!loading">
                        <v-col
                                v-for="(client,index) in clients"
                                :key="client.id"
                                cols="12" sm="6" md="4" lg="3">
                            <router-link
                                    :to="{ name: 'Client',
                                     params: {id: client.id,
                                      name: client.name,
                                       avatarsColors: avatarsColors,
                                        index: index}}">
                                <v-item v-slot:default="{ active, toggle }">
                                    <ClientsListItem
                                            :client="client"
                                            :index="index"
                                            :avatarsColors='avatarsColors'
                                    ></ClientsListItem>
                                </v-item>
                            </router-link>
                        </v-col>
                    </template>
                    <v-col cols="12" sm="6" md="4" lg="3" class="new-item-container">
                        <ClientsListNewItem v-on:clientAdded="getClients"></ClientsListNewItem>
                    </v-col>
                </v-row>
            </v-container>
        </v-item-group>
    </v-container>

</template>

<script>
    import ClientsListItem from '../components/Clients/ClientsListItem'
    import ClientsListNewItem from '../components/Clients/ClientsListNewItem'
    import CardLoader from '../components/CardLoader'
    import axios from 'axios'

    export default {
        name: "ClientsList",
        components: {
            ClientsListItem,
            ClientsListNewItem,
            CardLoader
        },
        data: () => ({
            avatarsColors: ['#17203A', '#c2cfe0', '#D64C33', '#334d6e', '#2ed47a', '#109cf1'],
            clients: [],
            loading: true,
        }),
        mounted() {
            this.getClients();
        },
        methods: {
            getClients: function () {
                axios.get('/domains').then(resp => {
                    this.clients = resp.data.domains;
                    this.loading = false;
                })
            }
        }
    }
</script>

<style scoped>

</style>
